import { useEffect } from 'react';
import useAppArtists from './useAppArtists';
import useAppPacks from './useAppPacks';
import useAppSeasons from './useAppSeasons';
import useCardTemplates from './useCardTemplates';
import { usePersistedSettings } from './useSettingsStore';
import { useAlertSocketHandlers } from './useAlertSocket';
import usePrevious from './usePrevious';
import { getCollectionCardTemplates, getCollections } from 'api/collections';

const useAppInitialize = () => {
  useAppPacks();
  useAppArtists();
  usePersistedSettings();
  useAlertSocketHandlers();
  useInitializeCollections();
};

const useInitializeCollections = () => {
  const { seasons } = useAppSeasons();
  const prevSeasons = usePrevious(seasons);
  const { setTemplates } = useCardTemplates();
  useEffect(() => {
    if (!prevSeasons?.length && seasons.length) {
      seasons.forEach(async (season) => {
        const { data: collections } = await getCollections(season);
        collections.forEach(async (collection) => {
          const { data: templates } = await getCollectionCardTemplates(
            collection.id
          );
          setTemplates(templates);
        });
      });
    }
  }, [prevSeasons, seasons, setTemplates]);
};

export default useAppInitialize;
